import { LimeError } from 'modules/application/misc/LimeError';
import { MessagingHubFeatures } from './MessagingHubFeatures';
import { isNullOrWhiteSpace } from 'data/string';
const HTTP_SESSION_HEADER = 'Http-Session';
const HTTP_SESSION_EXPIRATION_HEADER = HTTP_SESSION_HEADER + '-Expiration';
const HTTP_SESSION_MESSAGE_URL_HEADER = HTTP_SESSION_HEADER + '-Message-Url';
const HTTP_SESSION_NOTIFICATION_URL_HEADER = HTTP_SESSION_HEADER + '-Notification-Url';
const HTTP_SESSION_COMMAND_URL_HEADER = HTTP_SESSION_HEADER + '-Command-Url';
const HTTP_SESSION_MESSAGE_HEADERS_HEADER = HTTP_SESSION_HEADER + '-Message-Headers';
const HTTP_SESSION_NOTIFICATION_HEADERS_HEADER = HTTP_SESSION_HEADER + '-Notification-Headers';
const HTTP_SESSION_COMMAND_HEADERS_HEADER = HTTP_SESSION_HEADER + '-Command-Headers';
const HTTP_SESSION_ENSURE_IDENTITY_UNICITY = HTTP_SESSION_HEADER + '-Ensure-Identity-Unicity';
const HTTP_SESSION_OAUTH_AUTHORIZATION_SERVER_URI_HEADER = HTTP_SESSION_HEADER + '-OAuth-Authorization-Server-Uri';
const HTTP_SESSION_OAUTH_GRANT_TYPE_HEADER = HTTP_SESSION_HEADER + '-OAuth-Grant-Type';
const HTTP_SESSION_OAUTH_CLIENT_ID_HEADER = HTTP_SESSION_HEADER + '-OAuth-Client-Id';
const HTTP_SESSION_OAUTH_CLIENT_SECRET_HEADER = HTTP_SESSION_HEADER + '-OAuth-Client-Secret';
const OAUTH_CLIENT_CREDENTIALS_GRANT = 'client_credentials';
export const HTTP_SESSION_EXPIRATION_NONE = -1;
class MessagingHubServiceHttp {
    static $inject = ['$http', 'ApplicationService2', 'AuthenticationService', 'MessagingHubService', 'MESSAGINGHUBHTTPHOSTNAME'];
    constructor($http, ApplicationService2, AuthenticationService, MessagingHubService, MESSAGINGHUBHTTPHOSTNAME) {
        'ngInject';
        this.$http = $http;
        this.ApplicationService2 = ApplicationService2;
        this.AuthenticationService = AuthenticationService;
        this.MessagingHubService = MessagingHubService;
        this.baseUri = `https://${MESSAGINGHUBHTTPHOSTNAME}`;
    }
    async createHttpSession(application, httpTarget) {
        if (await MessagingHubFeatures.useWebsocketCommands()) {
            const key = application.accessKey;
            const commandResource = {
                authenticationScheme: 'key',
                authentication: {
                    key: key,
                },
                ensureIdentityUnicity: true,
                messageUrl: httpTarget.messageUrl,
                notificationUrl: httpTarget.notificationUrl,
            };
            if (httpTarget.messageUrl && this.hasHttpHeaders(httpTarget.messageHeaders)) {
                commandResource.messageHeaders = httpTarget.messageHeaders;
            }
            if (httpTarget.notificationUrl && this.hasHttpHeaders(httpTarget.notificationHeaders)) {
                commandResource.notificationHeaders = httpTarget.notificationHeaders;
            }
            if (httpTarget.oAuthAuthorizationServerUri) {
                commandResource.clientAuthenticationOptions = {
                    authorizationServerUri: httpTarget.oAuthAuthorizationServerUri,
                    clientId: httpTarget.oAuthClientId,
                    clientSecret: httpTarget.oAuthClientSecret,
                };
            }
            if (httpTarget.hidingOAuthSecret) {
                commandResource.oAuthSessionId = httpTarget.httpSessionId;
            }
            const response = await this.MessagingHubService.processCommand({
                method: 'set',
                uri: '/http-sessions',
                type: 'application/vnd.iris.server.http-session-configuration+json',
                resource: commandResource,
            });
            const httpSessions = this.MessagingHubService.ensureCommandSuccess(response).resource.items;
        }
        else {
            const headers = {
                Authorization: this.ApplicationService2.getAuthHeaderValue(application),
            };
            headers[HTTP_SESSION_HEADER] = 'reset';
            headers[HTTP_SESSION_EXPIRATION_HEADER] = httpTarget.expiration;
            headers[HTTP_SESSION_ENSURE_IDENTITY_UNICITY] = true;
            const toNameValue = object => {
                const keys = Object.keys(object);
                return keys.map(k => `${k}=${object[k]}`).reduce((v1, v2) => `${v1};${v2}`);
            };
            if (httpTarget.messageUrl) {
                headers[HTTP_SESSION_MESSAGE_URL_HEADER] = httpTarget.messageUrl;
                if (this.hasHttpHeaders(httpTarget.messageHeaders)) {
                    headers[HTTP_SESSION_MESSAGE_HEADERS_HEADER] = toNameValue(httpTarget.messageHeaders);
                }
            }
            if (httpTarget.notificationUrl) {
                headers[HTTP_SESSION_NOTIFICATION_URL_HEADER] = httpTarget.notificationUrl;
                if (this.hasHttpHeaders(httpTarget.notificationHeaders)) {
                    headers[HTTP_SESSION_NOTIFICATION_HEADERS_HEADER] = toNameValue(httpTarget.notificationHeaders);
                }
            }
            if (httpTarget.commandUrl) {
                headers[HTTP_SESSION_COMMAND_URL_HEADER] = httpTarget.commandUrl;
                if (this.hasHttpHeaders(httpTarget.commandHeaders)) {
                    headers[HTTP_SESSION_COMMAND_HEADERS_HEADER] = toNameValue(httpTarget.commandHeaders);
                }
            }
            if (httpTarget.oAuthAuthorizationServerUri) {
                headers[HTTP_SESSION_OAUTH_AUTHORIZATION_SERVER_URI_HEADER] = httpTarget.oAuthAuthorizationServerUri;
            }
            if (httpTarget.oAuthAuthorizationServerUri) {
                headers[HTTP_SESSION_OAUTH_GRANT_TYPE_HEADER] = OAUTH_CLIENT_CREDENTIALS_GRANT;
            }
            if (httpTarget.oAuthClientId) {
                headers[HTTP_SESSION_OAUTH_CLIENT_ID_HEADER] = httpTarget.oAuthClientId;
            }
            if (httpTarget.oAuthClientSecret) {
                headers[HTTP_SESSION_OAUTH_CLIENT_SECRET_HEADER] = httpTarget.oAuthClientSecret;
            }
            const { data } = await this.$http({
                method: 'POST',
                headers: headers,
                url: `${this.baseUri}/sessions`,
                data: {
                    state: 'new',
                    metadata: {
                        userEmail: this.AuthenticationService.email,
                    },
                },
            });
            const session = data;
            if (!session ||
                session.state !== 'established') {
                if (session?.reason) {
                    throw new LimeError({ code: session.reason.code, description: session.reason.description });
                }
                throw new Error('Invalid session result');
            }
        }
    }
    async getTwoWayHttpSession(application) {
        const sensitiveData = '**********';
        if (await MessagingHubFeatures.useWebsocketCommands()) {
            const response = await this.MessagingHubService.processCommand({
                method: 'get',
                uri: '/http-sessions?authenticationScheme=key',
            });
            const httpSessions = this.MessagingHubService.ensureCommandSuccess(response).resource.items;
            const twoWayHttpSession = httpSessions
                .find(httpSession => httpSession.messageUrl || httpSession.notificationUrl || httpSession.commandUrl);
            const httpTarget = {
                httpSessionId: twoWayHttpSession?.id,
                messageUrl: twoWayHttpSession?.messageUrl,
                notificationUrl: twoWayHttpSession?.notificationUrl,
                commandUrl: twoWayHttpSession?.commandUrl,
                messageHeaders: twoWayHttpSession?.messageHeaders,
                notificationHeaders: twoWayHttpSession?.notificationHeaders,
                commandHeaders: twoWayHttpSession?.commandHeaders,
                expiration: twoWayHttpSession?.expiration,
                oAuthAuthorizationServerUri: twoWayHttpSession?.clientAuthenticationOptions?.authorizationServerUri,
                oAuthClientId: twoWayHttpSession?.clientAuthenticationOptions?.clientId,
                oAuthClientSecret: (twoWayHttpSession?.clientAuthenticationOptions?.hidingOAuthSecret || !isNullOrWhiteSpace(twoWayHttpSession?.clientAuthenticationOptions?.clientSecret)) ? sensitiveData : twoWayHttpSession?.clientAuthenticationOptions?.clientSecret,
                oAuthGrantType: undefined,
                hidingOAuthSecret: (twoWayHttpSession?.clientAuthenticationOptions?.hidingOAuthSecret || !isNullOrWhiteSpace(twoWayHttpSession?.clientAuthenticationOptions?.clientSecret)),
            };
            return [undefined, httpTarget];
        }
        else {
            const { data, headers } = await this.$http({
                method: 'GET',
                headers: {
                    Authorization: this.ApplicationService2.getAuthHeaderValue(application),
                },
                url: `${this.baseUri}/sessions`,
            });
            const fromNameValue = (nameValue) => nameValue
                ?.split(';')
                .map(l => l.split('='))
                .reduce((acc, cur) => { acc[cur[0]] = cur[1]; return acc; }, {});
            const httpTarget = {
                messageUrl: headers(HTTP_SESSION_MESSAGE_URL_HEADER),
                notificationUrl: headers(HTTP_SESSION_NOTIFICATION_URL_HEADER),
                oAuthAuthorizationServerUri: headers(HTTP_SESSION_OAUTH_AUTHORIZATION_SERVER_URI_HEADER),
                oAuthGrantType: headers(HTTP_SESSION_OAUTH_GRANT_TYPE_HEADER),
                oAuthClientId: headers(HTTP_SESSION_OAUTH_CLIENT_ID_HEADER),
                oAuthClientSecret: !isNullOrWhiteSpace(headers(HTTP_SESSION_OAUTH_CLIENT_SECRET_HEADER)) ? sensitiveData : headers(HTTP_SESSION_OAUTH_CLIENT_SECRET_HEADER),
                commandUrl: headers(HTTP_SESSION_COMMAND_URL_HEADER),
                messageHeaders: fromNameValue(headers(HTTP_SESSION_MESSAGE_HEADERS_HEADER)),
                notificationHeaders: fromNameValue(headers(HTTP_SESSION_NOTIFICATION_HEADERS_HEADER)),
                commandHeaders: fromNameValue(headers(HTTP_SESSION_COMMAND_HEADERS_HEADER)),
                expiration: Number.parseInt(headers(HTTP_SESSION_EXPIRATION_HEADER)),
                httpSessionId: undefined,
                hidingOAuthSecret: !isNullOrWhiteSpace(headers(HTTP_SESSION_OAUTH_CLIENT_SECRET_HEADER)),
            };
            if (httpTarget.expiration != undefined && !isNaN(httpTarget.expiration) && httpTarget.expiration >= 0) {
                throw new Error("A two way http session can't have an expiration");
            }
            return [data, httpTarget];
        }
    }
    async closeHttpSession(application) {
        if (await MessagingHubFeatures.useWebsocketCommands()) {
            const [_, httpTarget] = await this.getTwoWayHttpSession(application);
            if (httpTarget.httpSessionId) {
                const response = await this.MessagingHubService.processCommand({
                    method: 'delete',
                    uri: `/http-sessions/${encodeURIComponent(httpTarget.httpSessionId)}`,
                });
                this.MessagingHubService.ensureCommandSuccess(response);
            }
        }
        else {
            await this.$http({
                method: 'POST',
                headers: {
                    Authorization: this.ApplicationService2.getAuthHeaderValue(application),
                    'Http-Session': 'close',
                },
                url: `${this.baseUri}/sessions`,
                data: { state: 'finishing' },
            });
        }
    }
    hasHttpHeaders(object) {
        return object && Object.keys(object).length > 0;
    }
}
MessagingHubServiceHttp.$inject = ['$http', 'ApplicationService2', 'AuthenticationService', 'MessagingHubService', 'MESSAGINGHUBHTTPHOSTNAME'];
export default MessagingHubServiceHttp;
